import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectCustomer, selectRegistrationNumber, selectVatnumber, selectShowInvalids } from '@store/partners-order/selectors';
import { setCustomer, setRegistrationNumber, setVatnumber } from '@store/partners-order/slice';
import TextField from '@components/text-field/TextField';
import { invalidFormValue } from '@components/utils';



const CLientInfo = () => {
	const { t } = useTranslation('forms');

	const customer = useSelector(selectCustomer);
	const registrationNumber = useSelector(selectRegistrationNumber);
	const vatNumber = useSelector(selectVatnumber);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateCustomer = (value: string | null) => dispatch(setCustomer(value));
	const updateRegistrationNumber = (value: string | null) => dispatch(setRegistrationNumber(value));
	const updateVatNumber = (value: string | null) => dispatch(setVatnumber(value));

	return (
		<div className='client-info-section'>

			<TextField
				label={t('inputLabels.partnerName')}
				required={true}
				value={customer ? customer : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateCustomer(null) : updateCustomer(value)}
				errorMessage={showInvalids && invalidFormValue(customer) ? t('validation.requiredField') : undefined} />

			
			<div className='company-info'>
				{process.env.SHOW_COMPANY_REGISTRATION_ID === 'TRUE' &&
					<TextField
						label={t('inputLabels.companyId')}
						required={true}
						value={registrationNumber ? registrationNumber : undefined}
						rounded={true}
						maxLength={8}
						onChange={(value: string) =>
							!value && value.length === 0 ? updateRegistrationNumber(null) : updateRegistrationNumber(value)}
						errorMessage={showInvalids && invalidFormValue(registrationNumber) ? t('validation.requiredField') : undefined} />
				}

				<TextField
					label={t('inputLabels.taxId')}
					required={true}
					value={vatNumber ? vatNumber : undefined}
					rounded={true}
					maxLength={10}
					onChange={(value: string) =>
						!value && value.length === 0 ? updateVatNumber(null) : updateVatNumber(value)}
					errorMessage={showInvalids && invalidFormValue(vatNumber) ? t('validation.requiredField') : undefined} />
			</div>

		</div>
	);
};

export default CLientInfo;